import React from 'react';

type FilterTagProps = {
    title: string;
    tagElements: string[];
    isHidden?: boolean;
};

const FilterTag = ({
    title,
    tagElements,
    isHidden = false,
}: FilterTagProps) => {
    if (isHidden) return null;

    const shouldPluralize =
        title.charAt(title.length - 1).toLowerCase() !== 's';
    const elementsLabel =
        tagElements.length > 3
            ? `${tagElements.length} ${shouldPluralize ? title + 's' : title}`
            : tagElements.join(' - ');

    return (
        <div
            data-test="filter-tag"
            className="gds-tag gds-tag--sm filter-custom-tag -m-b-2 -m-l-2"
        >
            <span className="gds-text--bold">{title}: </span>
            {elementsLabel}
        </div>
    );
};

export default FilterTag;
